import { createAction, props } from '@ngrx/store';
import {
  DashboardStatisticFilterEnum,
  DashboardStatisticItem,
  RecentlyCreatedOrModifiedItems
} from '../../shared/models/dashboard.model';

export const loadRecentActivity = createAction('[Dashboard] Load Recent Activity');
export const loadRecentActivitySuccess = createAction(
  '[Dashboard] Load Recent Activity Success',
  props<{ recentActivity: RecentlyCreatedOrModifiedItems[] }>()
);
export const loadRecentActivityFailure = createAction(
  '[Dashboard] Load Recent Activity Failure',
  props<{ error: any }>()
);

export const loadDashboardStatistics = createAction('[Dashboard] Load DashboardStatistics',
  props<{ filterItem: DashboardStatisticFilterEnum }>())
;
export const loadDashboardStatisticsSuccess = createAction(
  '[Dashboard] Load DashboardStatistics Success',
  props<{ dashboardStatistics: DashboardStatisticItem }>()
);
export const loadDashboardStatisticsFailure = createAction(
  '[Dashboard] Load DashboardStatistics Failure',
  props<{ error: any }>()
);
